import { SET_LAYOUT_SETTINGS_DATA_LOADING, SET_LAYOUT_SETTINGS_DATA, CLEAR_LAYOUT_SETTINGS_DATA } from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const findLayoutSettings = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LAYOUT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const queryParams = {
      companyId,
    };
    if (!companyId) {
      return false;
    }
    
    const res = await Axios.get('/api/dashboard/settings/find-layout-settings', {
      params: queryParams,
    });
    dispatch({
      type: SET_LAYOUT_SETTINGS_DATA,
      payload: res.data.data,
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_LAYOUT_SETTINGS_DATA,
      payload: [],
    });
    return false;
  }
}


export const updateLayoutSettings = (layoutSettings) => async (dispatch) => {
  try {
    dispatch({ type: SET_LAYOUT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const requestBody = {
      ...layoutSettings.layoutSettingsData,
    };

    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.post(`/api/dashboard/settings/update-layout-settings`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_LAYOUT_SETTINGS_DATA_LOADING, payload: false });
    return true;
  } catch (err) {
    dispatch({ type: SET_LAYOUT_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};